const isDevelopment = import.meta.env.MODE === 'development';

export class AppConfig {
    [key: string]: any; 
}


// Util: Load from sessionStorage if present
const loadFromSessionStorage = (): AppConfig | null => {
    const raw = sessionStorage.getItem('appConfig');
    if (!raw) return null;

    try {
        return JSON.parse(raw);
    } catch {
        console.warn('Invalid appConfig in sessionStorage');
        return null;
    }
};

let appConfig: AppConfig = loadFromSessionStorage() || {};

export const intializeProduct = () => {
    const product = getConfig('VITE_APP_PRODUCT');

    let title;
    switch (product) {
        case 'cake':
            title = 'Cake AI';
            break;
        case 'concierge':
            title = 'Concierge Admin';
            break;
        case 'mmadmin':
            title = 'Mad Mobile Admin';
            break;
        default:
            title = 'Admin';
    }

    const iconLink = document.getElementById('shortcut-icon') as HTMLLinkElement;
    if (iconLink) iconLink.href = `/products/${product}/favicon.ico`;

    document.title = title;

    const metaTag = document.querySelector('meta[name="apple-mobile-web-app-title"]');
    if (metaTag) {
        metaTag.setAttribute('content', title);
    }

    const manifestLink = document.createElement('link');
    manifestLink.rel = 'manifest';
    manifestLink.href = `/products/${product}/manifest.json`;

    const placeholder = document.getElementById('manifest-placeholder');
    if (placeholder) {
        console.log('replacing manifest placeholder', manifestLink);
        placeholder.replaceWith(manifestLink);
    }
};

export const loadAppConfig = async (csApiUrl?: string) => {
    const cached = loadFromSessionStorage();
    if (cached) {
        console.log('Using cached app config from sessionStorage');
        appConfig = cached;
        intializeProduct();
        return;
    }

    try {
        // Use provided URL or fall back to framework utility
        const apiUrl = csApiUrl || (await import('./api.config')).getBaseUrl();
        console.log('Loading app config from server:', apiUrl);
        const response = await fetch(`${apiUrl}/admin/appConfig`);
        appConfig = await response.json();
        sessionStorage.setItem('appConfig', JSON.stringify(appConfig));
        console.log('serverAppConfig:', appConfig);
        intializeProduct();
    } catch (error) {
        console.error('Failed to load runtime config', error);
    }
};

export const getConfig = (key: string): any => {
    if (key in appConfig) {
        return appConfig[key];
    }

    return import.meta.env[key];
};



/*const isDevelopment = import.meta.env.MODE === 'development';

export class AppConfig {
    [key: string]: any; 
}

let appConfig: AppConfig = {}

export const intializeProduct = () => {
    const product = getConfig('VITE_APP_PRODUCT');

    // select title based on a switch / case statement testing the value of product
    let title;
    switch (product) {
        case 'cake':
            title = 'Cake AI';
            break;
        case 'concierge':
            title = 'Concierge Admin';
            break;
        case 'mmadmin':
            title = 'Mad Mobile Admin';
            break;
    }
        
    // Update favicon
    const iconLink = document.getElementById('shortcut-icon') as HTMLLinkElement;
    if (iconLink) iconLink.href = `/products/${product}/favicon.ico`;

    // Update title
    document.title = title;

    // Update apple-mobile-web-app-title
    const metaTag = document.querySelector('meta[name="apple-mobile-web-app-title"]');
    if (metaTag) {
        metaTag.setAttribute('content', title);
    }

    // Replace manifest placeholder with correct link
    const manifestLink = document.createElement('link');
    manifestLink.rel = 'manifest';
    manifestLink.href = `/products/${product}/manifest.json`;

    const placeholder = document.getElementById('manifest-placeholder');
    if (placeholder) {
        console.log('replacing manifest placeholder', manifestLink);
        placeholder.replaceWith(manifestLink);
    }
}

export const loadAppConfig = async (csApiUrl) => {
    try {
      console.log('new loading app config', csApiUrl);
      const response = await fetch(`${csApiUrl}/admin/appConfig`);  
      appConfig = await response.json();
      console.log('serverAppConfig:', appConfig);

      intializeProduct();
    } catch (error) {
      console.error("Failed to load runtime config", error);
    }
  };
  
  // Function to access both static (build-time) and dynamic (runtime) config
  export const getConfig = (key: string): any => {
    // Check if the key is in the dynamic runtime config first
    if (key in appConfig) {
      return appConfig[key];
    }
  
    // Fallback to build-time variables injected by Vite
    return import.meta.env[key];
  };
*/